module.exports = __webpack_public_path__ + "img/ani_test_atlas_P_8.672301ab.png";